export const CONSTANTS = {
    _RAIN_STATUS_0_NOT_STARTED: 0,
    _RAIN_STATUS_0_WAIT_FOR_INTERNAL_VALIDATION: 0.3,
    _RAIN_STATUS_1_READY_TO_COMPUTE: 0.6,
    _RAIN_STATUS_1_READY: 1,

    _INPUT_VALIDITY_NOT_CHECKED_YET: -1,
    _INPUT_VALIDITY_CHECK_IN_PROGRESS: -0.5,
    _INPUT_VALIDITY_NOT_VALID: 0,
    _INPUT_VALIDITY_NOT_CONFIDENT: 0.5,
    _INPUT_VALIDITY_VALID: 1,
};
